import React, { createRef } from "react";
import { Menu } from "primereact/menu";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";

import Layout from "../../../Layout";
import Filter from "../../../components/filter/Filter";
import AdminOnly from "../../../components/AdminOnly";
import useLspLists from "../actions/useLspLists.js";
import LspLists from "./components/LspLists";
import API_ROUTES from "../../../api-routes";
import AuditSidebar from "../../../components/audit-sidebar/AuditSidebar";
import FilterDropdown from "../../../components/FilterDropdown";
import { Chip } from "primereact/chip";

const LSPListing = () => {
  const contextMenu = createRef();
  const {
    statevalues,
    handleAddNewLsp,
    filterOptions,
    setSelectedFilters,
    onLspPageChange,
    handleSearchChange,
    setIsAuditSidebarOpen,
    applyFilters,
    deSelectAll,
    setSelectedValues,
    chipData,
    handleRemoveFilter,
    uniqueServices,
  } = useLspLists();

  const auditLabels = () => {
    return {
      create: "Local Team Created",
      update: "Information Updated",
      delete: "Information Deleted",
    };
  };
  const auditNameLink = (data) => `/lsp/${data.original_pk}/dashboard`;

  const filterArray = filterOptions.map((item) => {
    if (item.id === "country") {
      return {
        ...item,
        suboptions: item?.suboptions.map((country) => ({
          name: getName(country),
          code: country,
          icon: (
            <ReactCountryFlag
              countryCode={country}
              svg
              style={{ marginRight: "8px", width: "1em", height: "1em" }}
            />
          ),
        })),
      };
    }
    return item;
  });

  return (
    <Layout
      title="Local Teams"
      subtitle="View and manage all registered Local Teams in one place.Easily add new partners, search, filter, and export data with CSV download."
    >
      <div className="card">
        <div className="formgrid grid pr-2 pl-2">
          <div
            className="field lg:col-6 md:col-12 sm:col-12 mb-0 p-0"
            style={{ paddingBottom: "5px" }}
          >
            <div className="input-search-container">
              <span className="pi pi-search"></span>
              <input
                type="text"
                placeholder="Search partners by trading name, country or service..."
                className="appearance-none outline-none w-full"
                value={statevalues?.searchLsp}
                onChange={handleSearchChange}
              />
              <span className="pi pi-search"></span>
            </div>
          </div>
          <div className="field lg:col-6 md:col-12 sm:col-12 mb-0 p-0">
            <div className="flex align-items-center justify-content-end gap-2">
              <FilterDropdown
                filterCount={chipData?.length}
                groupedOptions={filterArray}
                value={statevalues?.selectedFilters}
                onChange={(e) => {
                  setSelectedValues(e.grouped);
                  setSelectedFilters(e.value);
                }}
                applyFilter={applyFilters}
                deSelectAll={deSelectAll}
                placeholder="All events"
              />
              <AdminOnly>
                <button
                  className="btn onboard-entity"
                  type="button"
                  onClick={handleAddNewLsp}
                >
                  <span>Add New</span>
                  <i className="pi pi-plus ml-2"></i>
                </button>

                <Menu
                  className="global-entities-context-menu"
                  popup
                  ref={contextMenu}
                  id="context_menu"
                  model={[
                    {
                      label: (
                        <div className="global-entities-context-menu-item">
                          Download As CSV
                          <i className="pi pi-download" />
                        </div>
                      ),
                      // command: () => handleDownloadCSV(filteredEntities),
                    },
                    {
                      label: (
                        <div className="global-entities-context-menu-item">
                          View History
                          <i className="pi pi-history" />
                        </div>
                      ),
                      command: () => setIsAuditSidebarOpen(true),
                    },
                  ]}
                />
                <Button
                  onClick={(event) => contextMenu.current.toggle(event)}
                  icon="pi pi-ellipsis-v"
                  outlined
                  severity="success"
                />
              </AdminOnly>
            </div>
          </div>
        </div>
      </div>
      <div className="filter-chips-container">
        {chipData?.length ? `Filters (${chipData?.length})` : null}
        {chipData?.map((data) => (
          <Chip
            key={`${data?.category}-${data?.value}`}
            label={
              <span
                key={`${data?.category}-${data?.value}`}
                className="filter__chip"
              >
                {data?.category === "country" ? (
                  <span className="flex gap-1 align-items-center">
                    <ReactCountryFlag countryCode={data?.value} svg />
                    {getName(data?.value)}
                  </span>
                ) : (
                  uniqueServices[data?.value]
                )}{" "}
                <span className="cross__icon">
                  <i
                    className="pi pi-times"
                    onClick={() => handleRemoveFilter(data)}
                  />
                </span>
              </span>
            }
            removable={false}
          />
        ))}
      </div>
      <Card className="lsp-card mt-4">
        <LspLists
          data={statevalues.allLsp}
          handleAddNewLsp={handleAddNewLsp}
          onPageChange={onLspPageChange}
          lsplistpage={statevalues?.lsplistpage}
          lsplistlimit={statevalues?.lsplistlimit}
        />
      </Card>
      {statevalues?.isAuditSidebarOpen && (
        <AuditSidebar
          heading="Local Teams"
          endpoint={API_ROUTES.FETCH_LSPS_AUDIT}
          setSidebarToggle={setIsAuditSidebarOpen}
          sidebarToggle={statevalues?.isAuditSidebarOpen}
          labels={auditLabels}
          nameLink={auditNameLink}
        />
      )}
    </Layout>
  );
};

export default LSPListing;
